import React, { useState } from 'react';

import { Container, Typography, Grid } from '@mui/material';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import PaymentMethodBillingDetailsSection from './PaymentMethodBillingDetailsSection';
import PaymentMethodCardSection from './PaymentMethodCardSection';

const PaymentMethodNew = () => {
  const [showCardSection, setShowCardSection] = useState(false);
  const [billingDetails, setBillingDetails] = useState(null);

  const handleBillingDetailsSubmit = async (values) => {
    setShowCardSection(true);
    setBillingDetails(values);
  };

  const handleCardCancel = () => {
    setShowCardSection(false);
  };

  return (
    <Container>
      <Grid container>
        <Grid size={12}>
          <Typography variant='h4' component='h2' align='center' gutterBottom>
            New Payment Method
          </Typography>
          {showCardSection ? (
            <Elements
              stripe={loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY)}
            >
              <PaymentMethodCardSection
                billingDetails={billingDetails}
                onCancel={handleCardCancel}
              />
            </Elements>
          ) : (
            <PaymentMethodBillingDetailsSection
              onSubmit={handleBillingDetailsSubmit}
              initialValues={billingDetails}
            />
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

export default PaymentMethodNew;
